import thunk from 'redux-thunk';
import { createBrowserHistory, createMemoryHistory } from 'history';

import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, compose, createStore } from 'redux';

import config from '../../config';
import rootSaga from '../sagas';
import createAjax from '../../lib/ajax';
import rootReducer from '../reducers/index';
import generateApi from '../../services';
import reduxBeaconMiddleware from '../middlewares/reduxBeacon';
import { inDevelopment, isBrowser } from '../../lib/utils';

const sagaMiddleware = createSagaMiddleware();

export const history = isBrowser() ? createBrowserHistory() : createMemoryHistory();

export function createStoreWithArgs(token) {
  //since the placeListings and guidelistings data doesn`t have a redux state.
  //we need not to put the initial state of placeListings to the redux state
  let getSession;
  if (token) {
    getSession = () => ({ token });
  } else {
    getSession = () => store.getState().user;
  }

  const ajax = createAjax(`${config.ENDPOINT}`, getSession);
  const api = generateApi(ajax, getSession);

  let preloadedState = {};
  if (isBrowser()) {
    preloadedState = window.__initialData__;
    delete window.__initialData__;
  }

  const composeEnhancers =
    inDevelopment() && isBrowser()
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
      : compose;

  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware, thunk.withExtraArgument(api), reduxBeaconMiddleware)
    )
  );

  sagaMiddleware.run(rootSaga);

  return store;

  //for server-side rendering
  // store.runSaga = sagaMiddleware.run;
  // store.closeSagas = () => store.dispatch(END);
}

const store = createStoreWithArgs();

export default store;



// WEBPACK FOOTER //
// ./src/redux/store/index.js